import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITableOptions } from '@modeso/aumico-lib-core-fe';
import { GetOrganizationChecklistDto } from '@modeso/aumico-lib-users-fe';

type ImportChecklistModalData = {
    checklists: GetOrganizationChecklistDto[];
};

@Component({
    selector: 'app-import-checklist-modal',
    templateUrl: './import-checklist-modal.component.html',
    styleUrls: ['./import-checklist-modal.component.scss'],
})
export class ImportChecklistModal implements OnInit {
    selectedRow: GetOrganizationChecklistDto;

    options: ITableOptions;
    @Input() data: ImportChecklistModalData;
    @Output() rowSelected = new EventEmitter<GetOrganizationChecklistDto>();
    checklists: GetOrganizationChecklistDto[];

    public ngOnInit() {
        this.checklists = this.data.checklists;
    }
    public onRowSelected(row: any) {
        this.selectedRow = row;
        this.rowSelected.emit(row);
    }

    public filterChecklists(searchTerm: string | null): void {
        if (!searchTerm) {
            this.checklists = this.data.checklists;
        }

        this.checklists = this.data.checklists.filter((checklist) => {
            if (!checklist.name) {
                return false;
            }
            return checklist.name.toLowerCase().includes(searchTerm.toLowerCase());
        });
    }
}
